import React from 'react';

import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Message from 'components/Message';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import './SkuOrderActionMenuRow.scss';

const { block, element } = bem('sku-order-action-menu-row');

export const SkuOrderActionIcon = ({ src, destructive = false }) => (
  <Isvg src={src} className={element('icon', { destructive })} aria-hidden />
);

SkuOrderActionIcon.propTypes = {
  src: PropTypes.string.isRequired,
  destructive: PropTypes.bool,
};

export const SkuOrderActionRowContent = ({ iconSrc, message, destructive = false, menu = false }) => (
  <span className={block({ destructive, menu })}>
    <SkuOrderActionIcon src={iconSrc} destructive={destructive} />
    <Message message={message} />
  </span>
);

SkuOrderActionRowContent.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  message: intlMessage.isRequired,
  destructive: PropTypes.bool,
  menu: PropTypes.bool,
};

const SkuOrderActionMenuRow = props => <SkuOrderActionRowContent menu {...props} />;

SkuOrderActionMenuRow.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  message: intlMessage.isRequired,
  destructive: PropTypes.bool,
};

export default SkuOrderActionMenuRow;
